import { useState } from "react";
import { liveCategories, liveStreams } from "@/mocks/index";

function formatViewers(n: number) {
  return n >= 10000 ? `${(n / 10000).toFixed(1)}万` : `${n}`;
}

export default function LiveSection() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? liveStreams : liveStreams.filter((s) => s.category === active);

  return (
    <section id="now" className="scroll-mt-20 bg-stone-950 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <div className="mb-3 flex items-center gap-2">
              <span className="live-dot h-2.5 w-2.5 rounded-full bg-red-500" />
              <span className="text-xs font-semibold uppercase tracking-widest text-red-400">LIVE NOW</span>
            </div>
            <h2 className="text-2xl font-black text-white md:text-4xl">正在现场 · 开播陪看</h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-stone-400 md:text-base">
              热点刚一出，就有人开播陪你一起看。连麦现场、陪看直播、影视切片，蹲一个就能追完整个话题。
            </p>
          </div>

          <div className="flex flex-wrap gap-2">
            {liveCategories.map((c) => (
              <button
                key={c}
                type="button"
                onClick={() => setActive(c)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  active === c
                    ? "bg-orange-500 font-semibold text-stone-950"
                    : "border border-white/10 bg-white/5 text-stone-300 hover:border-orange-400/40 hover:text-orange-300"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {list.map((s) => (
            <a
              key={s.id}
              href="#now"
              className="group overflow-hidden rounded-3xl border border-white/10 bg-white/[0.03] transition-colors hover:border-orange-500/40"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={s.image}
                  alt={`${s.streamer} 正在直播《${s.title}》`}
                  title={`${s.title} - 99吃瓜直播`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute left-3 top-3 flex items-center gap-1.5 rounded-full bg-stone-950/70 px-2.5 py-1 text-xs font-semibold text-red-400 backdrop-blur-sm">
                  <span className="h-1.5 w-1.5 rounded-full bg-red-500" />
                  LIVE
                </div>
                <span className="absolute right-3 top-3 rounded-full bg-stone-950/70 px-2.5 py-1 text-xs text-stone-300 backdrop-blur-sm">
                  {s.category}
                </span>
                <span className="absolute bottom-3 right-3 rounded-full bg-stone-950/70 px-2.5 py-1 text-xs text-orange-300 backdrop-blur-sm">
                  <i className="ri-user-heart-fill mr-1" />
                  {formatViewers(s.viewers)} 人在看
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold text-white md:text-lg">{s.title}</h3>
                <div className="mt-3 flex items-center justify-between">
                  <span className="flex items-center gap-2 text-sm text-stone-400">
                    <span className="flex h-7 w-7 items-center justify-center rounded-full bg-gradient-to-br from-orange-500 to-amber-400 text-xs font-bold text-stone-950">
                      {s.streamer.slice(0, 1)}
                    </span>
                    {s.streamer}
                  </span>
                  <span className="rounded-full bg-orange-500/15 px-2.5 py-1 text-xs font-medium text-orange-300">
                    热度 {s.heat}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <p className="mt-8 text-center text-xs text-stone-500">
          直播信息为演示内容，实际以各房间实时状态为准 · 更多现场正在赶来
        </p>
      </div>
    </section>
  );
}